/** 微信发货同步状态文案 */
export function wxShippingStatusText(status: number | null | undefined): string {
  const s = Number(status)
  if (s === 1) return '已成功'
  if (s === 2) return '失败待重试'
  if (s === 3) return '已跳过'
  return '未上传'
}

/**
 * 是否显示「补发货」：仅微信支付且微信发货尚未成功
 * payMethod: 1=微信 2=余额 3=支付宝
 * wxShippingSyncStatus: 1=已成功时不显示
 *
 * 后台按钮暂时隐藏（定时任务已自动补偿）；接口与逻辑仍保留，需要时改回 true 条件即可。
 */
export function canManualUploadShipping(order: any): boolean {
  return false
  // if (!order) return false
  // if (Number(order.payMethod) !== 1) return false
  // if (Number(order.payStatus) !== 1) return false
  // const sync = order.wxShippingSyncStatus
  // if (sync != null && Number(sync) === 1) return false
  // return true
}
